<template>
    <div class="page"> 
        <!-- 导航 -->
        <ListNav @showFullSwiper="showFullSwiper" :indexUrl="indexUrl"></ListNav>
        <!-- 电话 -->
        <div class="floatPhone flex_wrap">
            <div class="numBox flex_center">400-618-8989转806</div>
            <div class="icon bg_gradient_blue flex_center">
                <i class="iconfont icon-iconfont_photo"></i>
            </div>
        </div>
        <!-- main -->
        <router-view></router-view>
    </div>
</template>
<script>
  import ListNav from "@/components/ListNav";
  import ajaxService from '@/server/api.js'
  export default {
        data() {
            return {
                indexUrl:null //招标采购跳转链接
            };
        },
        components: {
            ListNav
        },
        created(){
            this.getJumpUrlList()
        },
        mounted(){
            new Image().src = '../../assets/imgs/swiper/swiper01.png';
            new Image().src = '../../assets/imgs/swiper/swiper02.png';
            new Image().src = '../../assets/imgs/swiper/swiper03.png';
            new Image().src = '../../assets/imgs/swiper/swiper04.png';
        },
        methods: {
            showFullSwiper(){
                this.$emit('showFullSwiper');
            },
            getJumpUrlList(){
                ajaxService.getJumpUrl().then(res=>{
                    // console.log('跳转url',res)
                    if(!res.ErrorCode){
                        let {index, list} = res.Data
                        this.indexUrl = list
                        
                    }
                })
            }
        },
  };
</script>
<style lang="scss" scoped>
.floatPhone{
    position: fixed;
    bottom: 1vh;
    right: 16vw;
    width: 2.17rem;
    height: .4rem;
    box-sizing: border-box;
    border: 1px solid #00A4DF;
    border-radius: .02rem;
    z-index: 1000;
    overflow: hidden;
    .numBox{
        width: calc(100% - .41rem);
        height: 100%;
        background-color: white;
        font-size: .14rem;
        color: #00A4DF;
    }
    .icon{
        width:.42rem;
        height: 100%;
        border-radius: 0 .02rem .02rem 0;
        color: white;
        position:absolute;
        right:0;
        top: 0;
        .iconfont{font-size: .26rem;}
    }
}
</style>


